<template>
  <div class="lang">
    <div
      class="lang__link"
      data-inner-select="languages"
      @click.prevent="$router.push({ name: 'Languages' })"
    >
      <img :src="generateLanguageIcon" data-lang-active :alt="get_lang" />
    </div>
    <div class="lang__hint hint notranslate">
      <div class="hint__list hint__list_decor lang__list">
        <template v-for="(lang, index) in languages" :key="index">
          <a
            href="#"
            :data-ya-lang="lang.dataLang"
            class="hint__item lang__item"
            :class="{
              hint__item_rr: lang.dataLang === 'en',
              hint__item_rl: lang.dataLang === 'no',
            }"
            :title="lang.name"
            @click="langClickHandler(lang)"
            translate="no"
          >
            <img :src="generateImgSrc(lang.imgSuffix)" :alt="lang.dataLang" class="lang__img" />
            <div class="hint__content">{{ lang.name }}</div>
          </a>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LanguageSwitcher',
  methods: {
    generateImgSrc(lang = 'en') {
      return require(`@/assets/images/lang/lg__${lang}.png`);
    },
    langClickHandler(lang) {
      this.$store.dispatch('update_lang', lang.dataLang);
      this.$store.dispatch('update_flag', lang.imgSuffix);
    },
  },
  computed: {
    get_lang: {
      get() {
        return this.$store.getters.get_lang;
      },
    },
    get_flag: {
      get() {
        return this.$store.getters.get_flag;
      },
    },
    generateLanguageIcon() {
      return this.generateImgSrc(this.get_flag);
    },
    languages: {
      get() {
        const langs = this.$store.getters.get_languages;
        return langs.slice().reverse();
      },
    },
  },
};
</script>

<style scoped></style>
